$(function () {
    if ($('form#EmployeeApplicationReviewForm').length > 0) {

        $("#btnRemoveApplication").click(function (e) {
            e.stopPropagation();
            e.preventDefault();

            if ($("form").valid()) {
                $("#removeApplicationModal").modal({
                    'backdrop': 'static'
                });
            }

            return false;
        });

        $(".btnConfirmRemove").on('click', function () {
            $("#IsRemovedApplication").val(true);
            $("form").submit();
        });

        $("#btnReactivate").on('click', function () {
            $("#IsReactivateApplication").val(true);
            $("form").submit();
        });

        $('[data-toggle="tooltip"]').tooltip({
            placement: "top",
            container: "body",
            trigger: "manual",
            html: true
        });
        // When exceptional approval is checked we need to show the exceptional approval detail panel.
        $("#IsExceptionalApproval").change(function () {
            if ($(this).is(":checked")) {
                $("#ExceptionalApprovalReasonCd").prop("disabled", false);
                $("#ExceptionalApprovalDetail").prop("disabled", false);
                $("#ExceptionalApprovalSection").show();
            } else {
                $("#ExceptionalApprovalReasonCd").val("0");
                $("#ExceptionalApprovalReasonCd").prop("disabled", true);
                $("#ExceptionalApprovalDetail").val("");
                $("#ExceptionalApprovalDetail").prop("disabled", true);
                $("#ExceptionalApprovalSection").hide();
            }
        });
        $("#IsExceptionalApproval").change();

        $("#SubmitButton").click(function () {
            $("#IsSaveDraft").val(false);
            return true;
        })

        $("#SaveDraftButton").click(function () {
            $("#IsSaveDraft").val(true);
            return true;
        })

        $(".funding-level-select").change(function () {
            var fundingLevelId = $(this).val();
            SetIsUntrained(fundingLevelId);
        });

        function SetIsUntrained(fundingLevelId) {
            // Don't show the fields if the application is not set as approved, or if the funding level can't select them
            var hideTrainedOnly = $("#RecommendedActionCd").val() != jsApprovedStatusCd || fundingLevelId == 0 || $("#UntrainedReliefStaffId").val() == fundingLevelId;
            var isConditional = $("input[name='IsConditional']:checked").val() == jsTrueString;

            if (hideTrainedOnly) {
                $(".trained-only").addClass('d-none');
            } else {
                $(".trained-only").removeClass('d-none');
            }

            if (!hideTrainedOnly && isConditional) {
                $(".conditional-end-date").removeClass('d-none');
            } else {
                $(".conditional-end-date").addClass('d-none');
            }
        }

        $("input[name='IsConditional']").change(function () {
            var isConditional = $("input[name='IsConditional']:checked").val() == jsTrueString;

            if (isConditional) {
                $(".conditional-end-date").removeClass('d-none');
            } else {
                $(".conditional-end-date").addClass('d-none');
            }
        });

        // Internal review status can only be saved as draft
        $("#RecommendedActionCd").change(function () {
            // $("#SubmitButton").show();

            if ($(this).val() == jsApprovedStatusCd) {
                $(".approved-only").removeClass("d-none");
            }
            else {
                //Disable and set to the first item in the list
                $(".approved-only").addClass("d-none");
                $("#AssignedFundingLevelId").val('0');
                $("#AssignedFundingLevelId").change();
            }

            if ($(this).val() == jsInternalReviewId) {
                $("#SubmitButton").hide();
            }
            else {
                $("#SubmitButton").show();
            }

            if ($("#IsEditMode").val() == jsTrueString) {
                $("#SubmitButton").show();

                var CommentRequired = $("#RecommendedActionCd").val() == jsClarifyStatusCd ||
                    $("#RecommendedActionCd").val() == jsDeniedStatusCd ||
                    ($("#RecommendedActionCd").val() == jsApprovedStatusCd && $("#IsExceptionalApproval").val() == true);
                if (CommentRequired == true) {
                    $("#CommentToOperator").prop("disabled", false);
                    $("#CommentToOperator").removeAttr("disabled");
                }
                else {
                    $("#CommentToOperator").prop("disabled", "disabled");
                }
            }

            $(".funding-level-select").change();
        });
        $("#RecommendedActionCd").change();


        if ($("#IsReadOnly").val() == "True") {

            $(".disable-read-only").each(function () {
                if ($(this).prop("nodeName").toLowerCase() == "a") {
                    $(this).addClass("invisible");
                } else {
                    if ($(this).hasClass("hide")) {
                        $(this).hide();
                    }
                    else {
                        var CommentRequired = $("#RecommendedActionCd").val() == jsClarifyStatusCd ||
                            $("#RecommendedActionCd").val() == jsDeniedStatusCd ||
                            ($("#RecommendedActionCd").val() == jsApprovedStatusCd && $("#IsExceptionalApproval").val() == true);

                        $(this).prop("disabled", true);

                        if ($("#IsEditMode").val() == jsTrueString && CommentRequired == true) {
                            $(".cmnt").prop("disabled", false);
                        }
                    }

                }
            });

            if ($("#IsReviewEnabled").val() == "False") {
                // Hide the review button if the application is in a status that can't be changed
                $("#StartReview").hide();
            } else if ($("#ReviewUserId").val().trim() != "" && $("#ReviewUserId").val().trim() != jsCurrentUserId) {
                // Need to change button label if another reviewer is reviewing it
                $("#StartReview").html(jsLabelTakeOverReview);
            }

            if ($("#IsDataCorrectionEnabled").val() == "False") {
                // Hide the review button if the application is in a status that can't be changed
                $("#CorrectDataErrors").hide();
            } 
        } else {
            // Hide the review button if the application is already under review by this user and not Readonly
            $("#StartReview").hide();
            $("#CorrectDataErrors").hide();
        }

        $("#AddNoteButton").click(function (e) {
            var newNote = $("#AddNote").val();

            if (newNote.trim() !== "") {

                var url = '';

                if (location.href.indexOf('/en/') > 0) {
                    url = location.href.split('/en/')[0] + '/en/admin/wageenhancement/AddNote/' + jsOper + '/' + jsId + '/';
                } else {
                    url = location.href.split('/fr/')[0] + '/fr/admin/wageenhancement/AddNote/' + jsOper + '/' + jsId + '/';
                }

                $.ajax({
                    url: url + "?noteText=" + newNote.trim(),
                    method: 'POST',
                    contentType: false,
                    processData: false,
                    success: function (res) {
                        if (res !== null && res !== undefined) {
                            var noteHtml = '<div class="row">';
                            noteHtml += '<label class="mb-0" >' + res.authorName + '</label>';
                            noteHtml += '</div>';
                            noteHtml += '<div class="row mb-2 sublabel">' + res.createdDate + '</div>';
                            noteHtml += '<div class="row">' + res.text + '</div>';
                            noteHtml += '<hr />';
                            $("#NoteContainer").append(noteHtml);
                            $("#AddNote").val("");
                            $("#IsNoteAdded").val(true);
                        }
                    }
                });
            }
        });
        $("#btnedit").click(function (event) {
            event.preventDefault();
            $("#IsEditMode").val(jsTrueString);

            $(".disable-exception").each(function () {

                if ($(this).hasClass("hide")) {
                    $(this).show();
                }
                else {
                    $(this).prop("disabled", false);
                }
            });

        })
        if ($("#IsEditMode").val() == jsTrueString) {
            $(".disable-exception").each(function () {

                if ($(this).hasClass("hide")) {
                    $(this).show();
                }
                else {
                    $(this).prop("disabled", false);
                }
            });
        }
        if ($("#IsDataCorrectionMode").val() == "True") {
            $(".disable-data-correction").each(function () {

                if ($(this).hasClass("hide")) {
                    $(this).hide();
                }
                else {
                    $(this).prop("disabled", true);
                }
            });
        }
        // remove internal review when in edit button mode
        if ($("#btnedit").length > 0) {
            $("#RecommendedActionCd option[value='7']").remove();
        }

    } // if ($('form#EmploymentRecordDetailsForm').length > 0)
}); // $(function () {